export default {"src":"/_next/static/media/love-black.b2bb9dbd.svg","height":44,"width":43,"blurWidth":0,"blurHeight":0};